<template>
  <div class="flex h-full min-h-0 w-full flex-col">
    <!-- スクロール可能なカレンダーエリア -->
    <div class="min-h-0 flex-1 overflow-auto px-4 md:px-10">
      <DatePickerCalendar :default-select="props.defaultDates" @selection-change="handleDatesChange" />
    </div>
    <!-- 固定位置のTime of Dayエリア -->
    <div class="shrink-0 border-t border-stone-300 px-4 md:px-10">
      <TimeOfDayPicker :default-select="props.defaultTimeOfDay" :on-selection-change="handleTimeOfDayChange" :on-time-range-change="handleTimeRangeChange" />
    </div>
  </div>
</template>

<script setup lang="ts">
import DatePickerCalendar from '@/components/molecules/DatePickerCalendar/DatePickerCalendar.vue';
import TimeOfDayPicker from '@/wabunka-src/common/components/stateful/TimeOfDayPicker/TimeOfDayPicker.vue';
import type { TimeOfDayValue, TimeRange } from '@/wabunka-src/common/components/stateful/TimeOfDayPicker/types';

interface Props {
  defaultDates?: string[];
  defaultTimeOfDay?: TimeOfDayValue[];
  onDatesChange?: (dates: Map<string, string>) => void;
  onTimeOfDayChange?: (timeOfDay: Set<TimeOfDayValue>) => void;
  onTimeRangeChange?: (timeRange: TimeRange | null) => void;
}

const props = withDefaults(defineProps<Props>(), {
  defaultDates: () => [],
  defaultTimeOfDay: () => [],
  onDatesChange: undefined,
  onTimeOfDayChange: undefined,
  onTimeRangeChange: undefined,
});

const handleDatesChange = (dates: Map<string, string>) => {
  props.onDatesChange?.(dates);
};

const handleTimeOfDayChange = (timeOfDay: Set<TimeOfDayValue>) => {
  props.onTimeOfDayChange?.(timeOfDay);
};

const handleTimeRangeChange = (timeRange: TimeRange | null) => {
  props.onTimeRangeChange?.(timeRange);
};
</script>
